// special thanks
// https://qiita.com/kazumicho/items/53572ae56bb70b2e20d0

import React from "react";

const useAudio3 = url => {

  // same as React.Component.forceUpdate
  const [audio] = React.useState(new Audio(url));
  const [, _forceUpdate] = React.useState(false);
  const forceUpdate = () => _forceUpdate(prevState => !prevState);
  let [playing, setPlaying] = React.useState(false)
  let [played, setPlayed] = React.useState(false)

  React.useEffect(() => {

    audio.addEventListener("play", forceUpdate);
    audio.addEventListener("pause", forceUpdate);
    audio.addEventListener("ended", forceUpdate);
    audio.addEventListener("timeupdate", forceUpdate);
    audio.addEventListener("loadedmetadata", forceUpdate);

    return () => {
      audio.removeEventListener("play", forceUpdate);
      audio.removeEventListener("pause", forceUpdate);
      audio.removeEventListener("ended", forceUpdate);
      audio.addEventListener("timeupdate", forceUpdate);
      audio.addEventListener("loadedmetadata", forceUpdate);
      // audio.removeEventListener("timeupdate", forceUpdate);
    };

    audio.load()

    /**
     * about useEffect's second argument
     *    give nothing        => same as componentDidUpdate
     *    give an empty array => same as componentWillMount
     */

     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  React.useEffect(() => {

    audio.addEventListener("ended", _end);
    return () => {
      audio.removeEventListener("ended", _end);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _end = () => {
    setPlaying(false)
    setPlayed(true)
  }

  // const play = () => audio.play();
  const play = () => {
    if (audio) {
      setPlaying(true)
      audio.play();
    }
  }

  // const pause = () => audio.pause();
  const pause = () => {
    if (audio) {
      audio.pause();
      setPlaying(false)
    }
  };

  const setCurrentTime = (value) => {

    if (audio) {
      if (audio.readyState < 1) {
        audio.load()
      }
      audio.currentTime = value
    }
  }

  // const setDuration = (value) => {
  //   audio.duration = value
  // }

  if (audio) {
    return [play, pause, setCurrentTime, audio.currentTime, playing, played, audio.duration, audio];
  } else {
    return [play, pause, setCurrentTime, 0, playing, played, 0];
  }
};

export default useAudio3;
